/*
 * -----------------------------------------------------------------------
 *  <copyright file="editable-grid.interface.ts" company="Triumph Research Intelligence">
 *      Copyright (C) 2023 by Triumph Research Intelligence. All rights reserved.
 *  </copyright>
 * -----------------------------------------------------------------------
 */

import { ChangeEvent } from 'react';
import {
    IDisabledFields,
    StudyOverviewTableConfigurationColumnConfigurations,
    // eslint-disable-next-line max-len
} from '@components/admin/studies/study-settings-dialogs/edit-overview-tables/edit-study-site-overview-config/edit-study-site-overview-config.interface';
// eslint-disable-next-line max-len
import { StudyOverviewPanel } from '@components/admin/studies/study-settings-dialogs/edit-overview-tables/panels-overview-grid/panels-overview-grid.interface';
import { Errors } from '@components/central-monitoring/panels/add-panel/interfaces';
import { ExtraMenuItem } from '@components/core/grid-header/grid-menu/grid-menu.interface';
import { SelectWithSearchDataArrayInterface } from '@components/core/select-with-categories/select-with-categories.interface';
import { StudyOverviewColumnConfigurationInput } from 'types/graphql-global-types';
// eslint-disable-next-line max-len
import { StudyFields_Study_studyOverviewTableConfiguration_StudyOverviewTableConfigurationType_columnConfigurations_StudyOverviewColumnConfiguration as StudyOverviewColumnConfiguration } from '@queries/generated/fragments.generated';

export enum EditableGridCellEditor {
    TEXT = 'text',
    SELECT = 'select',
}

export interface EditableGridColumn {
    label: string;
    field: string;
    id: string;
    cellEditor?: EditableGridCellEditor;
    disabled?: boolean;
    required?: boolean;
    minWidth?: number;
    show?: boolean;
    selectValues?:
        | ((field: string, order: number | null | undefined, value: string) => SelectWithSearchDataArrayInterface[])
        | SelectWithSearchDataArrayInterface[];
    validateFn?: (stateVal: StudyOverviewTableConfigurationColumnConfigurations) => void;
    showInactiveIcon?: (dataItem: any) => boolean;
}

export interface EditableGridInterface {
    items: StudyOverviewColumnConfigurationInput[] | StudyOverviewPanel[] | null | undefined;
    columns: EditableGridColumn[];
    title: string;
    setState?: (state: any) => void;
    errors?: Errors;
    setErrors?: (error: Errors) => void;
    defineDisabledFields?: (
        currentRow?: StudyOverviewTableConfigurationColumnConfigurations,
        isRowExist?: boolean,
    ) => void;
    disabledFields?: IDisabledFields[];
    addAction?: Function;
    extraMenuItems?: ExtraMenuItem[];
    className?: string;
    editable?: boolean;
    splitItemText?: boolean;
    disableDeleteSingle?: boolean;
    lineHeight?: string;
    customKey?: string;
}

export interface RenderFieldInputInterface {
    value: string | number | null;
    column: any;
    dataItem: StudyOverviewColumnConfiguration;
    onChange?: (e: ChangeEvent<HTMLInputElement>) => void;
    errors?: { [key: string]: string }[];
    setErrors?: (error: { [key: string]: any }) => void;
    currentOrderFocus: number | null;
    cursor: number | null;
    disabled: boolean;
    splitItemText?: boolean;
    addNewAction?: () => void;
}
